import React from 'react';

import { EnterpriseSignup } from 'src/enterprise/signup';
import { EnterpriseLayout } from 'src/components/layouts/enterprise-layout';
import { PageComponent } from 'src/types';
import type { EnterpriseLoyaltySignupPageProps } from './get-server-side-props';

const EnterpriseLoyaltySignupPage: PageComponent = ({ visitorGeo }: EnterpriseLoyaltySignupPageProps) => (
  <EnterpriseSignup visitorGeo={visitorGeo} />
);

EnterpriseLoyaltySignupPage.layout = EnterpriseLayout;

export default EnterpriseLoyaltySignupPage;

// getServerSideProps must NOT be exported from this file (even as a re-export): Next reserves
// the literal filename "page.tsx" for the App Router and refuses to build any
// getServerSideProps export reachable through a module with that name. Route files import it
// directly from ./get-server-side-props instead -- see that file.
